export const companyInfo = {
  name: 'NovoCode Tecnologia',
  email: 'contato@novocode.com.br',
  phone: '+55 (47) 98881-5799',
  whatsapp: '5547988815799',
  address: 'Brasil — 100% remoto',
  social: {
    instagram: 'https://instagram.com/novocode.tec',
    linkedin: 'https://www.linkedin.com/company/novocode-tecnologia-e-sistemas-ltda',
    github: 'https://github.com/NovoCode-Tec',
  },
};

export const navLinks = [
  { id: 'servicos', label: 'Serviços', href: '#servicos' },
  { id: 'como-funciona', label: 'Como funciona', href: '#como-funciona' },
  { id: 'faq', label: 'FAQ', href: '#faq' },
  { id: 'contato', label: 'Contato', href: '#contato' },
];